import React, { Component } from "react";
import Select from "../../common/Select";
import Progress from "../../common/Progress";
import Input from "../../common/Input";
import { Redirect } from "react-router-dom";
import { NavLink } from "react-router-dom";
import BackArrow from "../../common/BackArrow";
import { api } from "../../common/server";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  rizevo_login_data: state.rizevo_login_data,
  token: state.token,
  getOptions: state.getOptions,
  postOptions: state.postOptions,
  percentageCut: state.percentageCut,
  userProfile: state.userProfile,
});
export default connect(mapStateToProps)(
  class Onboarding extends Component {
    state = {
      receivePayments: true,
      redirect: false,
      errors: {},
      loading: false,
    };
    receivePayments = (bool) => {
      this.setState({ receivePayments: bool });
    };
    getBanks = () => {
      fetch(`${api}/banks`, this.props.getOptions())
        .then((r) => r.json())
        .then((obj) => {
          if (obj.data?.banks) {
            this.setState({ banks: obj.data.banks });
          }
        });
    };
    getAccountName = (bank_code, account_number) => {
      this.setState({ errors: {}, account_name: "", loading: true });

      const body = JSON.stringify({
        bank_code,
        account_number,
      });
      fetch(`${api}/banks/resolve`, { ...this.props.postOptions(), body })
        .then((r) => {
          this.setState({ loading: false });
          return r.json();
        })
        .then((obj) => {
          if (obj.success === false) {
            if (obj.errors) {
              obj.errors.map((err) => {
                return this.setState({
                  errors: { ...this.state.errors, [err.field]: err.message },
                });
              });
            }
          }
          this.setState({
            account_name:
              obj.data?.account_name !== "error"
                ? obj.data?.account_name
                : "couldn't find that account",
          });
        });
    };
    resolveAccountName = () => {
      if (
        this.state.bank_code &&
        this.state.account_number?.toString().length === 10
      ) {
        this.getAccountName(this.state.bank_code, this.state.account_number);
      } else if (this.state.bank_code) {
        this.setState({ account_name: "Account number should be 10 numbers" });
      } else if (this.state.account_number?.toString().length === 10) {
        this.setState({ account_name: "Please select a bank" });
      }
    };
    componentDidMount = () => {
      // if (this.props.userProfile.onboarding_complete === true) {
      //   this.setState({ redirect: "/" });
      // }
      // else{
      // this.getBanks();
      // }
      this.getBanks();
    };
    createBookingSettings = (body) => {
      //create booking settings...
      fetch(`${api}/business/booking-settings`, {
        ...this.props.postOptions(),
        body,
      })
        .then((r) => {
          return r.json();
        })
        .then((obj) => {

          if (obj.success === true) {
            this.next();
          } else {
            this.setState({ loading: false });
          }
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    };

    payOutSettings = async (ev) => {
      ev.preventDefault();
      const form = ev.currentTarget;

      const bookingSettingsBody = JSON.stringify({
        upfront_percentage_payment: form.upfront_percentage_payment.value,
        receive_payment: this.state.receivePayments,
      });

      const body = JSON.stringify({
        bank_code: form.bank_code.value,
        account_number: form.account_number.value,
        account_name: form.account_name.value,
        bank_name:
          form.bank_code.options[
            form.bank_code.options.selectedIndex
          ].getAttribute("data-bank-name"),
      });

      this.setState({ loading: true });

      try {
        const response = await fetch(`${api}/business/bank-accounts`, {
          ...this.props.postOptions(),
          body,
        });

        const data = await response.json(); // ALWAYS read body

        if (!response.ok) {
          this.setState({
            loading: false,
            account_name: data?.message || "Unable to save bank account",
          });
          return;
        }

        this.createBookingSettings(bookingSettingsBody);

      } catch (error) {
        console.error("Network error:", error);
        this.setState({
          loading: false,
          account_name: "Network error. Please try again.",
        });
      }
    };


    next = () => {
      const code = this.props.match.params.business_invite_code;
      this.setState({ redirect: "/" });
      // this.setState({
      //   redirect: `/onboarding/team/invite/${code}`,
      // });
    };

    render() {
      return (
        <div className="onboarding-page">
          {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}

          <Progress total={5} current={5}>
            <div className="form-title dsk">
              Set your payout details
              <p>
                What percentage do you want clients to pay upfront? And which
                bank account should your money be sent to?
              </p>
            </div>
            <div id="onboarding-payout-dsk" className="onboarding-payout-setting-notice">
              <div className="notice-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="#363636" width="30px" height="30px" viewBox="0 0 32 32" version="1.1">
                  <title>account number notice</title>
                  <path d="M15.5 3c-7.456 0-13.5 6.044-13.5 13.5s6.044 13.5 13.5 13.5 13.5-6.044 13.5-13.5-6.044-13.5-13.5-13.5zM15.5 27c-5.799 0-10.5-4.701-10.5-10.5s4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5zM15.5 10c-0.828 0-1.5 0.671-1.5 1.5v5.062c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-5.062c0-0.829-0.672-1.5-1.5-1.5zM15.5 20c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5z"/>
                </svg>
              </div>
              <p>
                During payment, a different account number will be generated. 
                However, your payout will be sent to your account automatically within 10 minutes.
              </p>
            </div>
          </Progress>

          <div className="form_step form-page">
            <div className="form-title mbl">
              <span className="flex center form-title" style={{ padding: 0 }}>
                {/* <BackArrow /> */}
                Set your payout details
              </span>
              <p>
                What percentage do you want clients to pay upfront? And which
                bank account should your money be sent to?
              </p>
              <div id="onboarding-payout" className="onboarding-payout-setting-notice">
                <div className="notice-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="#363636" width="30px" height="30px" viewBox="0 0 32 32" version="1.1">
                    <title>account number notice</title>
                    <path d="M15.5 3c-7.456 0-13.5 6.044-13.5 13.5s6.044 13.5 13.5 13.5 13.5-6.044 13.5-13.5-6.044-13.5-13.5-13.5zM15.5 27c-5.799 0-10.5-4.701-10.5-10.5s4.701-10.5 10.5-10.5 10.5 4.701 10.5 10.5-4.701 10.5-10.5 10.5zM15.5 10c-0.828 0-1.5 0.671-1.5 1.5v5.062c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v-5.062c0-0.829-0.672-1.5-1.5-1.5zM15.5 20c-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5 1.5-0.672 1.5-1.5-0.672-1.5-1.5-1.5z"/>
                  </svg>
                </div>

                <p>
                  During payment, a different account number will be generated. 
                  However, your payout will be sent to your account automatically within 10 minutes.
                </p>
              </div>
            </div>
            <div className="form-container card restrict">
              {/* <div className="header flex space-btw">
                <p className="title">
                  Would you like to receive payments through Rizevo?
                </p>
                <Toggle
                  data_open={this.state.receivePayments}
                  OnChange={this.receivePayments}
                />
              </div> */}

              <form
                onSubmit={this.payOutSettings}
                style={{
                  display: this.state.receivePayments === true ? "" : "none",
                }}
              >
                <Select
                  label="What percentage of payment do you require?"
                  placeholder="Select %"
                  name="upfront_percentage_payment"
                  required
                >
                  {this.props.percentageCut?.map((percentage) => {
                    return percentage === "100" ? (
                      <option value={percentage} selected>
                        {percentage}%
                      </option>
                    ) : (
                      <option value={percentage}>{percentage}%</option>
                    );
                  })}
                </Select>
                <Select
                  label="Bank name"
                  placeholder="Select bank"
                  onChange={(e) => {
                    this.setState({ bank_code: e.currentTarget.value });
                    setTimeout(this.resolveAccountName, 0);
                  }}
                  name="bank_code"
                  required
                >
                  {this.state.banks?.map((bank) => (
                    <option value={bank.code} data-bank-name={bank.name}>
                      {bank.name}
                    </option>
                  ))}
                </Select>
                <Input
                  label="Account number"
                  type="number"
                  placeholder="e.g. 1234567890"
                  name="account_number"
                  onChangeAction={(value) => {
                    this.setState({ account_number: value });
                    setTimeout(this.resolveAccountName, 0);
                  }}
                  error={this.state.errors.account_number}
                  required
                />
                <Input
                  label="Account name"
                  type="text"
                  name="account_name"
                  placeholder="This field prefills"
                  value={this.state.account_name}
                  required
                />
                <div className="footer flex center space-btw">
                  {/* <button
                    className="left-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      this.createBookingSettings(
                        JSON.stringify({
                          receive_payment: this.state.receivePayments,
                          upfront_percentage_payment: 100,
                        })
                      );
                    }}
                    type="button"
                  >
                    I'll do this later
                  </button> */}
                  <button
                    className={
                      "default" + (this.state.loading ? " loading" : "")
                    }
                  >
                    Finish
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
  }
);
